export class ParentModel {
    private _internal_id = Math.random();
    constructor(
        public entryId: number,
        public index: number,
        public entryNumber: number,
        public gid: number,
        public designation: string,
        public cross: string,
        public source: string,
        public studyName: string
    ) {
    }

    get internal_id() {
        return this._internal_id;
    }
}
